export function Logo({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 font-display text-lg font-semibold tracking-tight ${className}`}>
      <svg viewBox="0 0 64 64" className="size-7" aria-hidden>
        <rect width="64" height="64" rx="14" fill="var(--primary)" />
        <path d="M18 40c0-8 6-14 14-14s14 6 14 14H18z" fill="#fff" />
        <rect x="14" y="42" width="36" height="4" rx="2" fill="#fff" />
        <circle cx="32" cy="22" r="3" fill="#fff" />
      </svg>
      Dishfolio
    </span>
  );
}
